import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import SuccessBox from 'components/Web_User_Interface/1440p_Series/System/Backup/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import BackupTable from 'components/Web_User_Interface/1440p_Series/System/Backup/backupTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "System Menü // Software Backup",
  "path": "/Web_User_Interface/1440p_Serie/System/Backup/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Sichern Sie Ihre Kameraeinstellungen.",
  "image": "./WebUI_1440p_SearchThumb_System_Backup.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_System_Backup.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const EuiSpacer = makeShortcode("EuiSpacer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEOHelmet title='System Menü // Software Backup' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Sichern Sie Ihre Kameraeinstellungen.' image='/images/Search/WebUI_1440p_SearchThumb_System_Backup.png' twitter='/images/Search/WebUI_1440p_SearchThumb_System_Backup.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/System/Backup/' locationFR='/fr/Web_User_Interface/1440p_Series/System/Backup/' crumbLabel="Backup" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "system-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#system-men%C3%BC",
        "aria-label": "system menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`System Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/47067cb03bfed8b92d3f564aa2bc4378/024d6/1440p_Settings_System_Backup.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "50%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACRUlEQVQoz2WR3UtTYRyA92dEiUTmdj423YaF7mw7Z+fsQ3e28332oeZN4UUFKmYSukiDQoq6CCEwyWjiRVddFQVSd9FN0D/0xE5aRhcP7/vCy8PD7xdLpVIkkylEIU42V8a8c0B15YDq0j767Veot/b+QTs5a8v72OtvaXQWGTp/jgtDQwwPDxOTZRlZTiIkRplQysz1+nR7fWZ7h3R6h7Q2+v8RbvSZu3/IwtYRFecakiAgy2NIUpKYJEkMEEWR9PgYgTVDN7BouSaBPRO9Q6f+F3uG0KrjN6Zx6lV0zaBYMNDUCkpOPS2UI2Emm8VvtQm7s4TtToQftnA8P8L1AmzfI7t1BfGFzNW7k9TLJppWoljQmZosnBEKAulMhvlmk+tmg67tEHoeLdcldJw/BI6N021gLpg0Ok18p0bF0KLK3NRZofhb2LYt5q0GHdsitO2I1gDXpeX5tL2AOdujYwe0vZDZdpWKoUaFSu6MUBIF5LEsO0sexzsuR5s2rcDD8QI818Zb3MBdP8C6+YQHeo1dtcyqUcGyDMqaSkXXKOTzxAazO11KMplEVxWmdYVmzcCsm1hNk+lajcD3WVtdZn1zm+ePH7H37Cmvt7dZmw8oqQUqegkllycmRCuXkWSZwX3k8igXL42QTk+gqQZGSadWrvDw3jLv3uzy6esXfnw/5tuH9/z8/JGXKzeolwuoxRK5qZPCQdlppSSJSKJIIpEgkRCIxxNkxlMYxRwFRUFVixhqHlWZQtc1JifGSUmJ6F88HucXonF7A1BL2yYAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/47067cb03bfed8b92d3f564aa2bc4378/e4706/1440p_Settings_System_Backup.avif 230w", "/de/static/47067cb03bfed8b92d3f564aa2bc4378/d1af7/1440p_Settings_System_Backup.avif 460w", "/de/static/47067cb03bfed8b92d3f564aa2bc4378/7f308/1440p_Settings_System_Backup.avif 920w", "/de/static/47067cb03bfed8b92d3f564aa2bc4378/7733b/1440p_Settings_System_Backup.avif 961w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/47067cb03bfed8b92d3f564aa2bc4378/a0b58/1440p_Settings_System_Backup.webp 230w", "/de/static/47067cb03bfed8b92d3f564aa2bc4378/bc10c/1440p_Settings_System_Backup.webp 460w", "/de/static/47067cb03bfed8b92d3f564aa2bc4378/966d8/1440p_Settings_System_Backup.webp 920w", "/de/static/47067cb03bfed8b92d3f564aa2bc4378/85db8/1440p_Settings_System_Backup.webp 961w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/47067cb03bfed8b92d3f564aa2bc4378/81c8e/1440p_Settings_System_Backup.png 230w", "/de/static/47067cb03bfed8b92d3f564aa2bc4378/08a84/1440p_Settings_System_Backup.png 460w", "/de/static/47067cb03bfed8b92d3f564aa2bc4378/c0255/1440p_Settings_System_Backup.png 920w", "/de/static/47067cb03bfed8b92d3f564aa2bc4378/024d6/1440p_Settings_System_Backup.png 961w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/47067cb03bfed8b92d3f564aa2bc4378/c0255/1440p_Settings_System_Backup.png",
              "alt": "Web User Interface - 1440p Series - System Backup",
              "title": "Web User Interface - 1440p Series - System Backup",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <BackupTable mdxType="BackupTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      